import 'react-grid-layout/css/styles.css';

import React from 'react';

import { Badge } from '@blockworks/ui';
import { Bit } from '@blockworks/ui/factory';

import { useDashboardGridContext } from '../context';

type ItemHeightBadgeProps = React.PropsWithChildren<{
    height: number;
}>;

const ItemHeightBadge = ({ height }: ItemHeightBadgeProps) => {
    const { isEditable } = useDashboardGridContext();
    if (!isEditable) return null;
    return (
        <Bit.div pos="absolute" right={2} bottom={2}>
            <Badge intent="neutral" size="xs">
                H: {height}
            </Badge>
        </Bit.div>
    );
};

type GridItemPlaceholderProps = {
    resizingItemHeight: number;
};

const GridItemPlaceholder = ({ resizingItemHeight }: GridItemPlaceholderProps) => {
    return (
        <Bit.div w="full" h="full" bgColor="raised">
            <ItemHeightBadge height={resizingItemHeight} />
        </Bit.div>
    );
};

export { GridItemPlaceholder, ItemHeightBadge };
